import { useEffect, useLayoutEffect, useState } from "react";
import MapaAnimacao from "../mapa-animacao/MapaAnimacao";
import { useAuth } from "../../auth/context/AuthProvider";
import "./LoginPage.css";

const BASE_W = 1920;
const BASE_H = 1080;

const getScale = () => {
  if (typeof window === "undefined") return 1;
  const sw = window.innerWidth / BASE_W;
  const sh = window.innerHeight / BASE_H;
  return Math.min(sw, sh);
};

export default function LoginPage() {
  const [s, setS] = useState(getScale);
  const { login, booting } = useAuth();

  // Apply login-scoped styles before first paint to avoid visual flash.
  useLayoutEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  useEffect(() => {
    const fit = () => setS(getScale());
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);

  const MAP = { left: 0, top: 0, width: 818.73 * s, height: 1080 * s };
  const RAILS = { left: 38 * s, top: 45 * s, width: 728 * s, height: 885 * s };

  const PUBLIC = process.env.PUBLIC_URL || "";

  const handleLogin = async () => {
    try {
      await login();
    } catch {
      window.location.href = "/auth/rumo";
    }
  };

  return (
    <div className="login-viewport">
      <div
        className="bg-cover"
        style={{ backgroundImage: `url(${PUBLIC}/img/trem-imagem-fundo.jpg)` }}
      />
      <div className="bg-overlay" />

      <div className="footer-bar" style={{ height: 37 * s }} />

      <div
        className="login-stage"
        style={{
          "--fx": s,
          "--fy": s,
          "--ui-shift-x": "96px",
          "--logos-shift-x": "28px",
        }}
      >
        <MapaAnimacao
          mapSrc={`${PUBLIC}/img/mapa-trilho.png?v=1`}
          baseSpeed={60}
          map={MAP}
          rails={RAILS}
        />

        <img
          className="ui-logo ui-logo-rumo"
          src={`${PUBLIC}/img/logo-rumo.png`}
          alt="RUMO / Malha Sul"
          draggable="false"
        />
        <img
          className="ui-logo ui-logo-pai"
          src={`${PUBLIC}/img/logo-pai.svg`}
          alt="PAI"
          draggable="false"
        />

        <section className="login-card" role="group" aria-label="Acesso">
          <h2 className="login-title">Acessar sua conta</h2>
          <button
            className="login-btn"
            onClick={handleLogin}
            disabled={booting}
            aria-busy={booting}
          >
            {booting ? "Preparando login..." : "Entre com sua conta RUMO"}
          </button>
          <div className="login-note">
            Você será direcionado para a página segura de login
          </div>
        </section>

        <footer className="login-footer">
          <div className="login-footer__inner">
            © 2025 RUMO — Malha Sul · Programação e Acompanhamento de Intervalos (PAI).
            Desenvolvimento: Lizandra Cordeiro, Luís dos Santos, Paulo Gonçalves e Pedro
            Seret. Coordenação: Rodrigo dos Santos · Co-coordenação: Taisa Utida.
          </div>
        </footer>
      </div>
    </div>
  );
}
